import { CheckCircleOutlined } from '@ant-design/icons';
import { InlineMetadata } from './InlineMetadata';
import React from 'react';
export const InlineCheckmarkMetadata = ({ label, value }) => React.createElement(InlineMetadata, { label: label }, value ? React.createElement(CheckCircleOutlined, null) : null);
